import BridgeV2 from "@akulaku/web-bridge";
import Router from "@al/next/router";

const isIos = () => {
  return process.browser && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

// 通用返回方法
const goBack = () => {
  // 宿主app
  if (BridgeV2.isAkulaku()) {
    BridgeV2.backackByStep({ count: 1 });
  } else {
    //宿主浏览器
    if (isIos()) {
      Router.back();
    } else {
      window.close();
    }
  }
};

export default goBack;
